import { render, staticRenderFns } from "./TemporaryArticles.vue?vue&type=template&id=61425098&lang=pug"
import script from "./TemporaryArticles.vue?vue&type=script&lang=js"
export * from "./TemporaryArticles.vue?vue&type=script&lang=js"
import style0 from "./TemporaryArticles.vue.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports